import React from 'react';
import { Link } from 'react-router-dom';
const destinations = [{
  id: 1,
  name: 'Turkey',
  image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
  description: 'Discover the beauty of Istanbul, Cappadocia, and the Turkish Riviera',
  highlights: ['Istanbul', 'Cappadocia', 'Antalya', 'Pamukkale', 'Bodrum']
}, {
  id: 2,
  name: 'Dubai',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Experience luxury and adventure in the city of gold',
  highlights: ['Burj Khalifa', 'Palm Jumeirah', 'Dubai Mall', 'Desert Safari', 'Miracle Garden']
}, {
  id: 3,
  name: 'Thailand',
  image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Explore tropical beaches and ancient temples',
  highlights: ['Bangkok', 'Phuket', 'Chiang Mai', 'Krabi', 'Phi Phi Islands']
}, {
  id: 4,
  name: 'Malaysia',
  image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1164&q=80',
  description: 'Visit Kuala Lumpur, Penang, and beautiful island resorts',
  highlights: ['Kuala Lumpur', 'Penang', 'Langkawi', 'Borneo', 'Cameron Highlands']
}, {
  id: 5,
  name: 'Europe',
  image: 'https://images.unsplash.com/photo-1503917988258-f87a78e3c995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
  description: 'Discover the rich history, culture, and beauty of Europe',
  highlights: ['Paris', 'Rome', 'Barcelona', 'London', 'Amsterdam']
}, {
  id: 6,
  name: 'Maldives',
  image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1965&q=80',
  description: 'Experience paradise on earth with crystal clear waters and overwater bungalows',
  highlights: ['Male', 'Overwater Villas', 'Snorkeling', 'Diving', 'Island Hopping']
}];
const Destinations = () => {
  return <div className="bg-white" data-id="element-486">
      <div className="relative bg-blue-600 text-white" data-id="element-487">
        <div className="container mx-auto px-4 py-24 relative z-10" data-id="element-488">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-489">
            Our Destinations
          </h1>
          <p className="text-xl text-center max-w-3xl mx-auto" data-id="element-490">
            Explore our handpicked destinations around the world
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-491">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-492">
          {destinations.map(destination => <div key={destination.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300" data-id="element-493">
              <div className="h-64 overflow-hidden" data-id="element-494">
                <img src={destination.image} alt={destination.name} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-495" />
              </div>
              <div className="p-6" data-id="element-496">
                <h3 className="text-2xl font-semibold mb-3" data-id="element-497">
                  {destination.name}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-498">{destination.description}</p>
                <div className="mb-6" data-id="element-499">
                  <h4 className="font-medium text-gray-900 mb-2" data-id="element-500">
                    Highlights:
                  </h4>
                  <div className="flex flex-wrap gap-2" data-id="element-501">
                    {destination.highlights.map((highlight, index) => <span key={index} className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded" data-id="element-502">
                        {highlight}
                      </span>)}
                  </div>
                </div>
                <Link to={`/destinations/${destination.id}`} className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium" data-id="element-503">
                  View Packages
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Destinations;